.list-item {
    display: flex;
    flex-direction: row;
}

.list-item--default-padding {
    padding: 12px 0;
}

.list-item--space-between {
    justify-content: space-between;
}

.actions {
    display: flex;
    align-items: center;
    padding: 0 16px;
}

.actions--no-padding {
    padding: 0;
}
